import i18next from 'i18next';

export const standardClasses = () => {
    return [
        { class: 0, name: i18next.t('product.nonStandard') },
        { class: 1, name: i18next.t('product.standardClass') + ' ' + 1 },
        { class: 2, name: i18next.t('product.standardClass') + ' ' + 2 },
    ];
};
